module.exports = __webpack_public_path__ + "img/20220219_072000.ee95950c.jpg";